import { getDocumentTitle } from '@/helpers/printing';
import { PrintRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import { RefObject } from 'react';
import { useReactToPrint } from 'react-to-print';

interface IProps {
  printContainerRef: RefObject<HTMLDivElement>;
}

const PrintReportButton = ({ printContainerRef }: IProps) => {
  const handlePrint = useReactToPrint({
    documentTitle: getDocumentTitle('Insights Reporting'),
    content: () => printContainerRef.current ?? null,
  });

  return (
    <Button
      variant='contained'
      startIcon={<PrintRounded />}
      sx={{ height: '40px', width: '200px' }}
      onClick={handlePrint}
    >
      <span>Print PDF Report</span>
    </Button>
  );
};

export default PrintReportButton;
